import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { ProfileComponent } from './profile/profile.component';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalRedirectComponent } from '@azure/msal-angular';
import { ReactiveFormsModule } from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatMenuModule} from '@angular/material/menu';
import { SoapRequestService } from './services/soap-request.service';
import { AppConfigService } from './services/app.config.service';
import { GraphqlService } from './graphql.service';
import { GraphQLModule } from './graphql.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ApplicationDescriptionComponent } from './home/application-description/application-description.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppAzureLoginDialogComponent } from './app-azure-login/app-azure-login-dialog.component';
import { FlexLayoutModule } from '@angular/flex-layout';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {

      // -----Muraai Id
      clientId: '65368371-568a-4d2b-b2e6-5239833d4f95',
      authority: 'https://login.microsoftonline.com/583bbc8b-b4b7-4e5f-900d-c0554b41e2eb',
      // redirectUri: 'https://demo.muraai.com/muraai-azure/'
      redirectUri: 'https://fe.vp.demos.muraai.com/'


      // -----Lupin Id
      // clientId: 'e1ba164a-0eac-491a-9ae2-2f199305605e',
      // authority: 'https://login.microsoftonline.com/a9c6fa70-d6e2-4563-adf3-0b24d921b140',
      // redirectUri: 'https://uat-scs.lupin.com/lupinAzure/',
      // redirectUri: 'http://locahost:4200'
      



    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);
  protectedResourceMap.set('http://localhost:8088/lvpm', ['user.read']);
  // protectedResourceMap.set('https://uat-scs.lupin.com/lvpm', ['user.read']);
  protectedResourceMap.set('https://be.vp.demos.muraai.com/lvpm', ['user.read']);
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return { 
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['user.read']
    }
  };
}
export function initializeAppConfigService(appConfigService: AppConfigService) {
  return (): Promise<any> => { 
    return appConfigService.load();
  }
}
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ProfileComponent,
    ApplicationDescriptionComponent,
    AppAzureLoginDialogComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatButtonModule,
    MatToolbarModule,
    MatListModule,
    HttpClientModule,
    MsalModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    HttpClientModule,
    FormsModule,
    MatSnackBarModule,
    MatCardModule,
    MatMenuModule,
    GraphQLModule,
    MatTooltipModule,
    MatDialogModule,
    MatIconModule,
    NgxSpinnerModule,
    FlexLayoutModule
  ],

  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    GraphqlService,
    SoapRequestService,
    { provide: APP_INITIALIZER,
      useFactory: initializeAppConfigService, 
      multi: true,
      deps: [
    AppConfigService] },
  ],
  schemas: [
		CUSTOM_ELEMENTS_SCHEMA,
		NO_ERRORS_SCHEMA
  ],  
  bootstrap: [AppComponent, MsalRedirectComponent],
  entryComponents: [AppAzureLoginDialogComponent]
})
export class AppModule { }
